import React from 'react';
import {FormBlock, FormBlockImage} from 'api';

interface Block extends FormBlock {
  formBlockable: FormBlockImage;
}

interface Props {
  block: Block;
}

export default ({block}: Props) => {
  const blockable = block.formBlockable;

  return blockable.image ? (
    <div className="flex justify-center">
      <a
        href={blockable.link}
        target="_blank"
        className="hover:opacity-90 focus:outline-none leading-none font-bold rounded cursor-pointer transition-all">
        <img
          src={blockable.image}
          style={{
            width: `${blockable.imageWidth * blockable.imageScale}px`,
          }}
        />
      </a>
    </div>
  ) : null;
};
